import { getCurrentInstance } from 'vue'

export function useAbility() {
    const instance = getCurrentInstance()!.proxy
    return instance.$ability
}
